'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from 'react';
import { SanityImage } from '@/components/SanityImage';
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle, DrawerTrigger } from '@/components/ui/drawer';
import { Button, IconButton } from '@/components/ui/button';
import { ReadButton } from '@/components/custom/ReadBtn';
type OverlayItem = {
  itemTitle: string;
  subtitle: string;
};
type Props = {
  itemTitle: string;
  subtitle: string;
  imageSrc: string;
  imageAlt: string;
  imageBlurDataURL?: string;
  overlayTitle?: string;
  overlayItems?: OverlayItem[];
};
export function WhatIsAiDrawerCard(t0) {
  const $ = _c(38);
  const {
    itemTitle,
    subtitle,
    imageSrc,
    imageAlt,
    imageBlurDataURL,
    overlayTitle,
    overlayItems
  } = t0;
  const [open, setOpen] = useState(false);
  const scrollYRef = useRef(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleOpen(isOpen) {
      if (isOpen) {
        scrollYRef.current = window.scrollY;
      } else {
        requestAnimationFrame(() => {
          window.scrollTo({
            top: scrollYRef.current,
            behavior: "instant"
          });
        });
      }
      setOpen(isOpen);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleOpen = t1;
  let t2;
  if ($[1] !== overlayItems) {
    t2 = overlayItems?.map(_temp).join(". ");
    $[1] = overlayItems;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const fullOverlayText = t2;
  const t3 = `${itemTitle} öffnen`;
  let t4;
  if ($[3] !== itemTitle) {
    t4 = <h5 className="text-lg md:text-xl text-center">{itemTitle}</h5>;
    $[3] = itemTitle;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = imageBlurDataURL ? "blur" : "empty";
  let t6;
  if ($[5] !== imageAlt || $[6] !== imageBlurDataURL || $[7] !== imageSrc || $[8] !== t5) {
    t6 = <SanityImage src={imageSrc} alt={imageAlt} fill={true} className="object-cover transition-transform duration-600 group-hover:scale-120" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 320px" placeholder={t5} blurDataURL={imageBlurDataURL} />;
    $[5] = imageAlt;
    $[6] = imageBlurDataURL;
    $[7] = imageSrc;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center lg:hidden"><span className="inline-flex items-center rounded-xs bg-(--color-softLinen)/90 px-4 py-2 text-md">Mehr</span></div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <div className="relative w-full aspect-square mt-4 overflow-hidden rounded-lg">{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t8) {
    t9 = <div className="w-full max-w-[320px] mx-auto flex flex-col items-center cursor-pointer group">{t4}{t8}</div>;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t9) {
    t10 = <DrawerTrigger asChild={true}><Button type="button" variant="ghost" aria-label={t3} className="h-auto w-full rounded-lg p-0 text-left hover:bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2">{t9}</Button></DrawerTrigger>;
    $[16] = t3;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = fullOverlayText ?? subtitle;
  let t12;
  if ($[19] !== t11) {
    t12 = <ReadButton text={t11} className="w-8 h-8 sm:w-10 sm:h-10 shrink-0" />;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = overlayTitle ?? itemTitle;
  let t14;
  if ($[21] !== t13) {
    t14 = <DrawerTitle asChild={true} className="text-2xl sm:text-4xl md:text-4xl leading-none text-center flex-1"><h3>{t13}</h3></DrawerTitle>;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <DrawerClose asChild={true}><IconButton icon="cancel" ariaLabel={"Schlie\xDFen"} iconColor="#db761c" iconSize={36} variant="ghost" size="icon" className="relative z-20 shrink-0 touch-manipulation pointer-events-auto" data-vaul-no-drag={true} /></DrawerClose>;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t12 || $[25] !== t14) {
    t16 = <DrawerHeader className="relative z-10 shrink-0 px-4 sm:px-6 md:px-10 flex flex-row justify-between items-center gap-2 sm:gap-4">{t12}{t14}{t15}</DrawerHeader>;
    $[24] = t12;
    $[25] = t14;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== overlayItems) {
    t17 = overlayItems?.map(_temp2);
    $[27] = overlayItems;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t17) {
    t18 = <div className="mt-4 px-4 md:px-20 pb-6 grid gap-4 flex-1 min-h-0 overflow-y-auto [-webkit-overflow-scrolling:touch] overscroll-contain [touch-action:pan-y]">{t17}</div>;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t16 || $[32] !== t18) {
    t19 = <DrawerContent className="px-4 md:px-8 pb-8 max-h-[80svh] will-change-transform flex flex-col">{t16}{t18}</DrawerContent>;
    $[31] = t16;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== open || $[35] !== t10 || $[36] !== t19) {
    t20 = <Drawer open={open} onOpenChange={handleOpen} shouldScaleBackground={false} setBackgroundColorOnScale={false}>{t10}{t19}</Drawer>;
    $[34] = open;
    $[35] = t10;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  return t20;
}
function _temp2(ovItem_0, ovIndex) {
  return <div key={ovIndex}><h5 className="text-base md:text-lg font-bold">{ovItem_0.itemTitle}</h5><p className="text-sm text-justify">{ovItem_0.subtitle}</p></div>;
}
function _temp(ovItem) {
  return `${ovItem.itemTitle}. ${ovItem.subtitle}`;
}